import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import IdleTimer from "react-idle-timer";
import "./scss/style.scss";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const EsqueceuSenha = React.lazy(() => import("./views/pages/EsqueceuSenha"));
const ResetarSenha = React.lazy(() => import("./views/pages/ResetarSenha"));
const GaleriaOng = React.lazy(() => import("./views/pages/GaleriaOng"));

const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

const onAction = (e) => {
  console.log("user did something", e);
};

const onActive = (e) => {
  console.log("user is active", e);
  // console.log("time remaining", this.idleTimer.getRemainingTime());
};

const onIdle = (e) => {
  console.log("user is idle", e);
  // console.log("last active", this.idleTimer.getLastActiveTime());
};

class App extends Component {
  render() {
    return (
      (
        <IdleTimer
          // ref={ref => { Null = ref }}
          element={document}
          onActive={onActive}
          onIdle={onIdle}
          onAction={onAction}
          debounce={250}
          timeout={10}
        />
      ),
      (
        <HashRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/esqueceu-senha"
                name="Esqueceu Senha"
                render={(props) => <EsqueceuSenha {...props} />}
              />
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} />}
              />
              <Route
                path="/reset/find/:token"
                name="Resetar senha"
                render={(props) => <ResetarSenha {...props} />}
              />
              <Route
                path="/galeria/:uuid"
                name="Galeria Ong"
                render={(props) => <GaleriaOng {...props} />}
              />
              <Route
                path="/"
                name="Home"
                render={(props) => <TheLayout {...props} />}
              />
            </Switch>
          </React.Suspense>
        </HashRouter>
      )
    );
  }
}

export default App;
